<template>
  <div class="exhibition">
    <common-layout>
      <div slot="header">
        <h3>展览展示</h3>
      </div>
      <div slot="container">
        <div class="exhibition.header">
          <div class="exhibition-search">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="add"
              style="background: #623aa2; border: none"
              >新增</el-button
            >
            <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
              >批量删除</el-button
            >
            <el-input
              placeholder="请输入内容"
              v-model="searchValue"
              class="input-with-select"
              @keyup.enter.native="search"
              clearable
              @clear="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
            <!-- <el-select
              style="width: 300px"
              v-model="srelease"
              placeholder="请选择发布平台"
              clearable
              @change="search"
            >
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select> -->
          </div>
        </div>
        <div class="exhibition-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.$index + (currentPage - 1) * per_page + 1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="展厅主题"
              align="center"
              prop="title"
            ></el-table-column>

            <el-table-column
              label="发布时间"
              align="center"
              prop="dateTime"
            ></el-table-column>
            <el-table-column label="展品详情" align="center">
              <template slot-scope="scope">
                <el-tag type="success" @click="jump(scope.row.id)">详情</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.isPublish == 2"
                  >确认发布</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="release(scope.row, 2)"
                  v-else
                  >取消发布</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="展览名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>

        <el-form-item label="展厅封面" prop="image" style="text-align: center">
          <el-upload
            style="text-align: left"
            :action="this.uploadURL"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="pictureCardPreview"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :http-request="HouImgFile"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-upload
            class="avatar-uploader"
            :action="this.uploadURL"
            name="file"
            :show-file-list="false"
            :on-success="handlePictureCardPreview"
            :before-upload="beforeAvatarUpload"
            :http-request="HouImgFile"
          >
            <img
              v-if="ruleForm.image"
              :src="imgUrl + ruleForm.image"
              class="img_border"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              :class="{ is_border: !ruleForm.image }"
            ></i>
            <span class="upload_btn" v-if="!ruleForm.image">上传图片</span>
            <span v-else class="upload_btn">更换图片</span>
          </el-upload> -->
          <!-- <span class="del_img" v-show="ruleForm.image">
            <i class="el-icon-error" @click="deleteImg"></i>
          </span> -->
        </el-form-item>
        <el-form-item label="时间" prop="dateTime">
          <el-date-picker
            v-model="ruleForm.dateTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择日期"
            style="text-align: left; width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="展厅简介" prop="introduction">
          <el-input
            type="textarea"
            v-model="ruleForm.introduction"
            placeholder="请输入简介"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否发布"
          prop="isPublish"
          style="text-align: left"
        >
          <el-switch
            v-model="ruleForm.isPublish"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </el-form-item>
        <el-form-item label="同步发布" prop="isMarket" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="closeForm('ruleForm')">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import { DisabledDateFn } from "../../utils/tool";
export default {
  components: { CommonLayout },
  data() {
    return {
      srelease: '',
      fileList: [],
      total: 10,
      per_page: 10,
      currentPage: 1,
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      Title: "",
      dialogFormVisible: false,
      searchValue: "",
      deleteRow: "",
      tableData: [],
      isMarket:1,
      ruleForm: {
        title: "",
        image: "",
        introduction: "",
        isPublish: 2,
        dateTime: "",
        isMarket: 1,
        isAchievement: 1,
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        introduction: [
          { required: true, message: "请输入简介", trigger: "blur" },
        ],
        dateTime: [
          {
            type: "string",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        // image: [{ required: true, message: "请上传封面图片", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getData("Service_Display_Theme");
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
          this.per_page = res.data.per_page;
        }
      });
    },
    //查看展品
    jump(val) {
      this.$router.push("/serviceInnovate/exhibition/" + val);
    },
    //新增
    add() {
      this.is_submit = true;
      this.isMarket = 1
      this.dialogFormVisible = true;
      this.Title = "新增展厅";
      this.ruleForm = {
        title: "",
        image: "",
        introduction: "",
        isPublish: 2,
        dateTime: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      this.Title = "编辑展厅";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.Exhibit = undefined
      this.isMarket =
        this.ruleForm.isAchievement === 1 && this.ruleForm.isMarket === 1
          ? 1
          : this.ruleForm.isMarket === 1
          ? 2
          : 3;
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image.split(",");
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          let arr = [];
          this.fileList.forEach((item) => {
            if (item.response) {
              arr.push(item.response.data.store_result);
            } else {
              arr.push(item.store_result);
            }
          });
          obj.image = arr.join(",");
          if (!obj?.id) {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/create`, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("新建成功");
                  this.getData("Service_Display_Theme");
                  this.fileList = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                  this.ResetSearch(["searchValue"]);
                } else {
                  this.is_submit = true;
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
          if (this.Title == "编辑展厅") {
            // delete obj.id;
            obj.id = this.ruleForm.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/update`, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("编辑成功");
                  this.getData("Service_Display_Theme");
                  this.fileList = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                  this.ResetSearch(["searchValue"]);
                } else {
                  this.is_submit = true;
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
      this.fileList = [];
    },
    //发布
    release(row) {
      let data = {};
      if (row.isPublish == 1) {
        data.isPublish = 2;
      } else if (row.isPublish == 2) {
        data.isPublish = 1;
      }
      data.id = row.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/update`, data).then((res) => {
        if (res.code == 0) {
          this.currentPage = 0;

          if (data.isPublish == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.info("已取消发布");
          }
          this.getData(
            "Service_Display_Theme?page=" +
              this.currentPage +
              "&title=" +
              this.searchValue +
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          );
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      if(this.searchValue){
        this.getData("Service_Display_Theme?title=" + this.searchValue + 
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : ''));
      }else{
        this.getData("Service_Display_Theme?"+ 
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : ''));
      }
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.currentPage = 0;
                this.getData(
                  "Service_Display_Theme?page=" +
                    this.currentPage +
                    "&title=" +
                    this.searchValue + 
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
                );
                this.ResetSearch(["searchValue"]);
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/service-display-theme/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData(
                    "Service_Display_Theme?page=" +
                      1 +
                      "&title=" +
                      this.searchValue + 
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
                  );
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的展厅",
        });
      }
    },
    formmarket(val) {
      if (val === 1) {
        this.ruleForm.isMarket = 1;
        this.ruleForm.isAchievement = 1;
      } else if (val === 2) {
        this.ruleForm.isMarket = 1;
        this.ruleForm.isAchievement = 2;
      } else {
        this.ruleForm.isMarket = 2;
        this.ruleForm.isAchievement = 1;
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData(
        "Service_Display_Theme?title=" + this.searchValue + "&page=" + val + 
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
      );
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // //上传图片
    // HouImgFile(e) {
    //   var files = e.file;
    //   if (!files) return;
    //   this.createImage(files, e, "HouImg");
    // },
    // //其他图片上传
    // createImage(file, e, Name) {
    //   //lrz压缩
    //   // lrz图片先压缩在加载、
    //   lrz(file, {
    //     width: 960,
    //   })
    //     .then((rst) => {
    //       this.http
    //         .post("/file/base64_upload", {
    //           image: rst.base64,
    //         })
    //         .then((res) => {
    //           this.ruleForm.image = res.data;
    //         });
    //       return rst;
    //     })
    //     .always(() => {
    //       // 清空文件上传控件的值
    //       e.target.value = null;
    //     });
    // },

    // handlePictureCardPreview(file) {
    //   this.ruleForm.image = file.data.store_result;
    // },
    // beforeAvatarUpload(file) {
    //   let type = false;
    //   if (
    //     file.type === "image/jpeg" ||
    //     file.type === "image/png" ||
    //     file.type === "image/jpg" ||
    //     file.type === "image/gif" ||
    //     file.type === "image/bmp"
    //   ) {
    //     type = true;
    //   }

    //   const isLt2M = file.size / 1024 / 1024 < 10;
    //   if (!type) {
    //     this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
    //   }
    //   if (!isLt2M) {
    //     this.$message.error("上传图片大小不能超过 10MB!");
    //   }
    //   return type && isLt2M;
    // },
    // deleteImg() {
    //   this.$confirm("确定删除图片吗?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     center: true,
    //   })
    //     .then(() => {
    //       this.ruleForm.image = "";
    //       this.$message({
    //         type: "success",
    //         message: "删除成功!",
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除",
    //       });
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
@include component(exhibition) {
  width: 100%;
  height: 100%;
  /deep/.el-tag {
    &:hover {
      cursor: pointer;
    }
  }
  .exhibition-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }
  .exhibition-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 200px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
